import React from 'react';
import { Grid } from '@material-ui/core';
import { Panel, Tooltip } from '@michelin/acid-components';
import { Info, Warning } from '@material-ui/icons';
import { useTranslation } from '@michelin/central-provider';
import { CSSProperties } from 'styled-components';
import FileUpload from '../../FileUpload/FileUpload';
import { usePromosDescription, usePromosMessage } from '../../../hooks/useAdminQueries';

const FileInfo = (props:any) => {
  const { t } = useTranslation();
  const iconStyle: CSSProperties = {
    marginTop: '5px', marginRight: '8px', cursor: 'pointer',
  };
  const { promo } = props;
  const promoStatus:string = usePromosDescription(promo.status);
  const promoMessage:string = usePromosMessage(promo.status, promo.message);
  return (
    <Panel
      title={`${promo.name} - ${promoStatus}`}
      variant="disabled"
      bordered={false}
      icon={(
        <Tooltip
          placement="top"
          arrow
          title={(
            <div>
              <small>
                <b>
                  {t('Created by')}
                </b>
                {' '}
                {promo.create_user.split('~').shift()}
                {' '}
                [
                {promo.created_date}
                ]
              </small>
              <br />
              <small>
                <b>
                  {t('Updated by')}
                </b>
                {' '}
                {promo.create_user.split('~').shift()}
                {' '}
                [
                {promo.update_date}
                ]
              </small>
              <br />
              <small>
                <b>
                  {t('Message')}
                </b>
                <br />
                {' '}
                {promoMessage}
              </small>
              {promo?.message?.version ? (
                <>
                  <br />
                  <small>
                    <b>
                      {t('Version')}
                    </b>
                    {' '}
                    {promo?.message?.version}
                  </small>
                </>
              ) : null}
            </div>
          )}
        >
          {promo.status === 'processed' ? <Info color="disabled" style={iconStyle} /> : <Warning color="error" style={iconStyle} />}
        </Tooltip>
     )}
    >
      <Grid container>
        <Grid item xs={12}>
          <FileUpload
            mode="minimal"
            readOnly
            label={`${promoMessage}`}
            data={promo.file}
            error={promo.status === 'error'}
            previewEnabled={false}
          />
        </Grid>
      </Grid>
    </Panel>
  );
};

export {
  FileInfo,
};
